export default __webpack_public_path__ + "static/media/daylightsun.d3e18dfb.png";